import { baseUrl } from './env'
import axios from 'axios'
import { Message } from 'element-ui'
// import store from '@/store'
// import i18n from '@/lang'
// import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  // headers: {
  //   Accept: 'application/json, text/plain, */*; charset=utf-8',
  //   'Content-Type': 'application/json; charset=utf-8',
  //   'Access-Control-Allow-Origin': '*',
  //   Pragma: 'no-cache',
  //   'Cache-Control': 'no-cache'
  // },
  // headers: {
  //   'Accept': 'application/json',
  //   'Content-Type': 'application/json',
  //   'Cache-Control': 'no-cache'
  //   // 'Pragma': 'no-cache',
  //   // 'Cache-Control': 'no-cache'
  // },
  // mode: 'cors',
  // cache: 'no-cache',
  baseURL: baseUrl, // api的base_url
  timeout: 5000, // request timeout
  withCredentials: true // 跨域同步请求
})
// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  // if (store.getters.token) {
  // config.headers['Cookie'] = 'language=zh; USER_TOKEN:db06595ba74c415ba81fbb4c8bffa236'
  // config.headers['Accept-Language'] = store.getters.language // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  // }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response.data.code === 'L02001') {
      // MessageBox.alert(error.response.data.message, i18n.t('commit.confirmLogout'), {
      //   confirmButtonText: i18n.t('commit.againLogin'),
      //   // cancelButtonText: '取消',
      //   type: 'warning',
      //   callback: action => {
      //     location.reload()
      //   }
      // })
      Message({
        // message: error,
        message: error.response.data.message,
        type: 'error',
        duration: 5 * 1000
      })
      // MessageBox.alert(error.response.data.message, '提示', {
      //   confirmButtonText: '重新登录',
      //   // cancelButtonText: '取消',
      //   type: 'warning',
      //   callback: action => {
      //     // location.reload()
      //     if (sessionStorage.getItem('moduleCode') === '3') {
      //       window.location.href = window.location.protocol + '//' + window.location.host + '/' + 'projectindex.html'
      //     } else {
      //       window.location.href = window.location.protocol + '//' + window.location.host + '/'
      //     }
      //   }
      // })
    } else {
      Message({
        // message: error,
        message: error.response.data.message,
        type: 'error',
        duration: 5 * 1000
      })
      // if (sessionStorage.getItem('moduleCode') === '3') {
      //   window.location.href = window.location.protocol + '//' + window.location.host + '/' + 'projectindex.html'
      // } else {
      //   window.location.href = window.location.protocol + '//' + window.location.host + '/'
      // }
    }
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/config/config.js